// extracted by mini-css-extract-plugin
export default {"Vcard":"Transaction_Vcard__zRttr","VAcctTxt":"Transaction_VAcctTxt__rmsmC","VFundTxt":"Transaction_VFundTxt__x7w53","VBank":"Transaction_VBank__SFg-8"};